module.exports = __webpack_public_path__ + "static/media/kts02.a65b7f77.png";